import { PaginaOperaciones } from '../components/PaginaOperaciones'
import type { Recepcion } from '../types'

export default function Recepciones() {
  return (
    <PaginaOperaciones<Recepcion>
      titulo="Recepciones"
      recurso="recepciones"
      llave="id"
      columnas={[
        { campo: 'folio', titulo: 'Folio' },
        { campo: 'proveedorNombre', titulo: 'Proveedor' },
        { campo: 'almacenNombre', titulo: 'Almacen' },
        { campo: 'estado', titulo: 'Estado' },
        { campo: 'fechaProgramada', titulo: 'Fecha programada', render: (r) => r.fechaProgramada?.split('T')[0] || '-' },
      ]}
      campos={[]}
      valorInicial={{}}
      puedeCrear={false}
      acciones={[
        {
          label: 'Ejecutar',
          endpoint: (r) => `recepciones/${r.id}/ejecutar`,
          body: (r) => ({ id: r.id, estado: 'EnEjecucion' })
        },
        {
          label: 'Autorizar',
          endpoint: (r) => `recepciones/${r.id}/autorizar`,
          body: (r) => ({ id: r.id, estado: 'Autorizado' }),
          metodo: 'PUT'
        }
      ]}
    />
  )
}
